export default {
    state: {
        // 场地概况
        placeOverview: {},
        // 场地客流情况
        placePassengerFlow: {},
        // 场地业态分布
        placeDistributionIndustry: {},
        // 场地周边交通
        placeSurroundingTraffic: {},
        // 商圈概况
        tradingAreaOverview: {},
        // 商圈业态分布
        tradingAreaDistributionIndustry: {},
        // 商圈热门品牌
        tradingAreaHotBrand: [],
        // 城市概况
        cityOverview: {},
        // 经济概况
        cityEconomics: {},
        // 商业概况
        cityBusiness: {},
        // 交通情况
        cityTraffic: {}
    },
    actions: {},
    mutations: {
        // 场地概况
        PLACE_OVERVIEW: function (state, val) {
            state.placeOverview = val;
        },
        // 场地客流情况
        PLACE_PASSENGE_FLOW: function (state, val) {
            state.placePassengerFlow = val;
        },
        // 场地业态分布
        PLACE_DISTRIBUTION_INDUSTRY: function (state, val) {
            state.placeDistributionIndustry = val;
        },
        // 场地周边交通
        PLACE_SURROUNDING_TRAFFIC: function (state, val) {
            state.placeSurroundingTraffic = val;
        },
        // 商圈概况
        TRADING_AREA_OVERVIEW: function (state, val) {
            state.tradingAreaOverview = val;
        },
        // 商圈业态分布
        TRADING_AREA_DISTRIBUTION_INDUSTRY: function (state, val) {
            state.tradingAreaDistributionIndustry = val;
        },
        // 商圈热门品牌
        TRADING_AREA_HOT_BRAND: function (state, val) {
            state.tradingAreaHotBrand = val;
        },
        // 城市概况
        CITY_OVERVIEW: function (state, val) {
            state.cityOverview = val;
        },
        // 经济概况
        CITY_ECONOMICS: function (state, val) {
            state.cityEconomics = val;
        },
        // 商业概况
        CITY_BUSINESS: function (state, val) {
            state.cityBusiness = val;
        },
        // 交通情况
        CITY_TRAFFIC: function (state, val) {
            state.cityTraffic = val;
        }
    },
    getters: {}
};
